import  {  useEffect } from "react";
import { recoilStates } from "./recoilStates";
import { useRecoilState } from "recoil";
import { createTeeshotAxiosInstance } from "src/http";
import { useAlert } from "src/hooks";
import { SreenCoverLoading } from "../components";

export default function InitRecoil() {
  const [group, setGroup] = useRecoilState(recoilStates.group);
  const [isInit, setInit] = useRecoilState(recoilStates.init);
  const [user, setUser] = useRecoilState(recoilStates.user);
  const [eventApplication, setEventApplication] = useRecoilState(recoilStates.eventApplication);
  const [_5, setBookingApplication] = useRecoilState(recoilStates.bookingApplication);
  const [_6, setCommonData] = useRecoilState(recoilStates.commonData);
  const alert = useAlert();

  useEffect(() => {
    (async () => {
      if (!user.id) {
        return;
      }
      const isYearBooking = window.location.pathname.includes("year-booking");
      const isEventBooking = window.location.pathname.includes("event-booking");

      if (isYearBooking) {
        try {
          setInit({ isInit: false });

          const groupRes = await createTeeshotAxiosInstance().get("/yearBooking/group");
          if (groupRes.data.success === false) {
            throw new Error("group 조회 실패");
          }
          const groupData = groupRes?.data?.data;
          setGroup({ ...groupData.group, members: groupData.members });
          const [yearBookingRes, commonRes] = await Promise.all([
            createTeeshotAxiosInstance().get("/yearBooking/booking"),
            createTeeshotAxiosInstance().get("/common/groupBooking"),
          ]);

          if (yearBookingRes?.data?.data) {
            setBookingApplication(yearBookingRes?.data?.data);
          }
          if (commonRes?.data?.data) {
            setCommonData(commonRes.data.data);
          }

          setInit({ isInit: true });
        } catch (e) {
          alert(String(e));
        }
      }
      if (isEventBooking) {
        try {
          setInit({ isInit: false });
          const [eventRes, commonRes] = await Promise.all([
            createTeeshotAxiosInstance().get("/evtBooking/booking"),
            createTeeshotAxiosInstance().get("/common/groupBooking"),
          ]);

          setEventApplication(eventRes?.data?.data);

          if (eventRes?.data?.data) {
            setEventApplication(eventRes?.data?.data);
          }
          if (commonRes?.data?.data) {
            setCommonData(commonRes.data.data);
          }

          setInit({ isInit: true });
        } catch (e) {
          alert(String(e));
        }
      }
    })();
  }, [user?.id]);

  return <>{!isInit?.isInit && <SreenCoverLoading />}</>;
}
